export enum EProxyTypeEnums {
    CHRM = 'CHRM',
    DISC = 'DISC',
    NEPR = 'NEPR',
    HLDR = 'HLDR'
}
